import { GET_DOCUMENT, RESET_DOCUMENT } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface DocumentState extends BaseAsyncReducerState {
    document?: Record<string, unknown>;
}
// Define an initial state value for the app
const initialState: DocumentState  = {
    loading: false,
    error: false
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function documentReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_DOCUMENT.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_DOCUMENT.SUCCESS:
            return {
                ...state,
                document: payload,
                loading: false,
                error: false
            }
        case GET_DOCUMENT.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_DOCUMENT:
            return {
                ...state,
                document: null,
                ...initialState
            }
        default:
            return state
    }
}

export default documentReducer;
